import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_ALLOWANCES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_ALLOWANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_ALLOWANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_ALLOWANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_ALLOWANCE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
